<template>
  <div class="patient-name">
    <span class="name">{{ info.patientName }}</span>
    <span class="gender"
      ><Icon v-if="info.sex == '男'" type="md-male" />
      <Icon v-else type="md-female" />
      {{ info.sex }}</span
    >
    <span class="age"
      ><template v-if="info.patientAge > 1">{{ info.patientAge }}岁</template>
      <template v-else>
        <template v-if="info.birthMonth">{{
          info.birthMonth + "个月"
        }}</template>
      </template></span
    >
    <span class="phone">{{ info.cellphoneNo }}</span>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.patient-name {
  font-size: 14px;
  margin-bottom: 10px;
  & > span {
    margin-right: 10px;
  }
  .name {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>